export default {
  label: {
    en: 'Email address',
  },
}
